var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.66388 8.3518L1.60788 13.4078L0.783879 12.5838L5.83988 7.5278C6.13588 7.2318 6.13588 6.7598 5.83988 6.4638L0.775879 1.4158L1.59988 0.591797L6.65588 5.6478C7.40788 6.3998 7.40788 7.6078 6.65588 8.3598L6.66388 8.3518Z","fill":"#4C4C4C"}));
}

Arrow.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none","className":"icon"};

module.exports = Arrow;

Arrow.default = Arrow;
